import { useHistory } from 'react-router-dom';
import routes from '../../../../components/Routes/routingMap';

const useOpenRegisterform = () => {
  const history = useHistory();
  const openLink = () => {
    history.push(routes.student.procedures.categories.tickets.register);
  };

  return { openLink };
};

export default useOpenRegisterform;
